import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Calling from "../containers/calling";
import { CallButtonAccept } from "../actions";
import { CallClientDisconnect } from "./calling";

var contadorToast = 1;
var coluna = "";

const mapStateToProps = (state) => {
  return {
    VerificarUser: state.informationusers,
    Messages: state.messages,
    InfoDisplay: state.infodisplay,
    StatusAgent: state.status,
    Atendimento: state.atendimento,
    ChatSimult: state.chatsimult,
    Chat: state.chatinternal,
    InfoUsers: state.informationusers,
    ContactId: state.atendimento,
    capturafila: state.capturequeue,
    AtdSimult: state.atdsimult,
  };
};

class ToastCalling extends Component {
  rejeitarChamada() {
    CallClientDisconnect();
  }
  atenderchamada(ContactId) {
    CallButtonAccept(ContactId);
  }

  render() {
    const { StatusAgent, InfoUsers, capturafila, ContactId, AtdSimult } =
      this.props;
    var checkAtd = false;

    if (AtdSimult.length !== 0) {
      AtdSimult.map((simult) => {
        if (
          parseInt(ContactId.idatendimento) ===
            parseInt(simult.idatendimento) &&
          parseInt(ContactId.idmidia) === 1
        ) {
          checkAtd = true;
        }
      });
    }

    checkAtd === true ? (checkAtd = true) : (checkAtd = false);

    if (ContactId.length !== 0) {
      if (checkAtd === false) {
        if (StatusAgent.status === "Chamando") {
          if (
            parseInt(ContactId.direction) === 1 &&
            InfoUsers.atdauto === false &&
            parseInt(ContactId.idmidia) === 1
          ) {
            if (capturafila.capturafila === true) {
              coluna = this.atenderchamada();
            } else {
              contadorToast++;
              coluna = <Calling key={ContactId.idatendimento} />;
            }
          }
        } else if (StatusAgent.status === "Livre") {
          coluna = this.rejeitarChamada();
        } else {
          coluna = "";
        }

        return (
          <div className="calling__content" key={ContactId.idatendimento}>
            {coluna}
          </div>
        );
      } else {
        if (capturafila.length !== 0) {
          if (
            capturafila.capturafila === true &&
            parseInt(ContactId.idmidia) === 1
          ) {
            coluna = this.atenderchamada(ContactId);
          }
        }

        return null;
      }
    } else {
      this.rejeitarChamada();
      return null;
    }
  }
}

export default connect(mapStateToProps, null)(ToastCalling);
